import React from "react";
import { Composition } from "remotion";

// Dynamically discover all .tsx files in compositions/
const compositionModules = require.context("./compositions", false, /\.tsx$/);

interface CompositionModule {
  default?: React.FC;
  DURATION_FRAMES?: number;
  [key: string]: unknown;
}

/** Find the component: prefer default export, fall back to first named FC */
function resolveComponent(mod: CompositionModule): React.FC | null {
  if (typeof mod.default === "function") return mod.default;
  for (const key of Object.keys(mod)) {
    if (key === "DURATION_FRAMES" || key === "__esModule") continue;
    if (typeof mod[key] === "function") return mod[key] as React.FC;
  }
  return null;
}

function getCompositions(): Array<{
  id: string;
  component: React.FC;
  durationInFrames: number;
}> {
  return compositionModules
    .keys()
    .filter((key: string) => !key.startsWith("./_"))
    .map((key: string) => {
      const mod: CompositionModule = compositionModules(key);
      const id = key.replace("./", "").replace(".tsx", "").replace(/_/g, "-");
      const component = resolveComponent(mod);
      if (!component) return null;
      return {
        id,
        component,
        durationInFrames: mod.DURATION_FRAMES || 900,
      };
    })
    .filter(Boolean) as Array<{ id: string; component: React.FC; durationInFrames: number }>;
}

const Placeholder: React.FC = () => (
  <div
    style={{
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#111",
      color: "#666",
      fontFamily: "Inter, sans-serif",
      fontSize: 24,
    }}
  >
    Genera un reel para previsualizarlo aqui
  </div>
);

export const RemotionRoot: React.FC = () => {
  const compositions = getCompositions();

  if (compositions.length === 0) {
    return (
      <Composition
        id="Placeholder"
        component={Placeholder}
        durationInFrames={150}
        fps={30}
        width={1080}
        height={1920}
      />
    );
  }

  return (
    <>
      {compositions.map(({ id, component, durationInFrames }) => (
        <Composition
          key={id}
          id={id}
          component={component}
          durationInFrames={durationInFrames}
          fps={30}
          width={1080}
          height={1920}
        />
      ))}
    </>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
